import './TrainingTheme.scss'

import React, { Component } from 'react'
import _ from 'lodash'
import { selectAgentTrainingCenterTopic, selectAgentTrainingCenterTopics } from 'manager/selectors/auth'
import { createStructuredSelector } from 'reselect'
import { setTitle } from 'common/redux/root'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import { TrainingCategoryContent } from 'manager/views/components/Training/TrainingCategoryContent'
import styled from 'styled-components'

const TrainingSidebarItem = ({ title, onClick, selected }) => (
  <TrainingThemeSidebar selected={selected} onClick={onClick}>{title}</TrainingThemeSidebar>
)

const TrainingThemeSidebar = styled.span`
${props => props.selected ?
  `border-left: 2px solid #0588dd;
  margin-left: -6px;
  padding-left: 6px;
  color: #4a4a4a !important;` :
  ''
}
`

class TrainingTheme extends Component {

  state = {
    selectedQuestion: null,
    isMobileView: false,
    dropdownVisible: false
  }

  componentDidMount = () => {
    const { setTitle } = this.props
    setTitle(null)
    this.updateViewType()
    window.addEventListener("resize", this.updateViewType)
  }

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateViewType);
  }

  updateViewType = () => {
    this.setState(() => ({ isMobileView: window.innerWidth <= 980 }))
  }

  toggleDropdown = () => {
    this.setState(({ dropdownVisible }) => ({ dropdownVisible: !dropdownVisible }))
  }

  push = (pathname) => {
    const { push } = this.props
    push({ pathname })
  }

  goToReferralManager = () => {
    // this.selectQuestion(null)
    this.push(``)
  }

  goToTrainingHome = () => {
    // this.selectQuestion(null)
    this.push(`/training`)
  }

  goToCategory = (slug) => {
    // this.selectQuestion(null)
    this.push(`/training/${slug}`)
  }

  // TODO: commenting this out until we have the ability to embed RDC iframes
  // selectQuestion = (selectedQuestion) => {
  //   this.setState({ selectedQuestion })
  // }

  openQuestionInNewWindow = (selectedQuestion) => {
    const { trainingCenterTopic } = this.props
    const { content = [] } = trainingCenterTopic
    const allQuestions = content.reduce((accum, contentItem) => [...accum, ...contentItem.content], [])
    const topicContentObject = _.find(allQuestions, { topic: selectedQuestion })
    if (topicContentObject && topicContentObject.link) {
      window.open(topicContentObject.link, '_blank')
    }
  }

  renderBody = () => {
    const { trainingCenterTopic } = this.props
    const { content = [] } = trainingCenterTopic
    // TODO: commenting this out until we have the ability to embed RDC iframes
    // const { selectedQuestion } = this.state
    // if (selectedQuestion) {
    //   const allQuestions = content.reduce((accum, contentItem) => [...accum, ...contentItem.content], [])
    //   const topicContentObject = _.find(allQuestions, { topic: selectedQuestion })
    //   if (topicContentObject && topicContentObject.link) {
    //     return (
    //       <iframe src={topicContentObject.link} height='100%' width='100%' />
    //     )
    //   }
    // }
    return (
      <div>
        { content.map((item, index) => {
          return (<TrainingCategoryContent key={index} onClick={this.openQuestionInNewWindow} {...item} />)
        })}
      </div>
    )
  }

  render() {
    const { trainingCenterTopic = {}, availableCategories } = this.props
    const { title, slug } = trainingCenterTopic
    const { selectedQuestion, isMobileView, dropdownVisible } = this.state

    if (!trainingCenterTopic) {
      return null
    }

    const additionalProps = selectedQuestion && { onClick: () => this.goToCategory(slug)}
    return (
      <TrainingThemeComponent>
        <TrainingThemeBreadcrumbs>
          <span onClick={this.goToReferralManager}>Referral Manager</span>
          <span onClick={this.goToTrainingHome}>Training Center</span>
          {title && <span {...additionalProps}>{title}</span>}
          {selectedQuestion && <span>{selectedQuestion}</span>}
        </TrainingThemeBreadcrumbs>
        <TrainingThemeContent>
          <TrainingThemeLeftNav dropdownVisible={dropdownVisible}>
            <span>Categories</span>
            { availableCategories.map(({ title, slug }) => {
              const props = {
                onClick: () => this.goToCategory(slug),
                title,
                selected: title == this.props.trainingCenterTopic.title
              }
              return (<TrainingSidebarItem key={title} {...props} />)
            })}
          </TrainingThemeLeftNav>
          <TrainingThemeBody>
            { this.renderBody() }
          </TrainingThemeBody>
        </TrainingThemeContent>
      </TrainingThemeComponent>
    )
  }
}

const selectors = createStructuredSelector({
  trainingCenterTopic: selectAgentTrainingCenterTopic,
  availableCategories: selectAgentTrainingCenterTopics
})

const actions = {
  push,
  setTitle
}

export default connect(selectors, actions)(TrainingTheme)

const TrainingThemeComponent = styled.div`
flex: 1;
height: 100%;
background-color: #F8F8F9;
`

const TrainingThemeBreadcrumbs = styled.div`
padding: 50px 5%;
display: flex;
align-items: center;
justify-content: flex-start;
padding-bottom: 90px;

span {
  font-family: 'Circular';
  font-weight: 500;
  font-size: 16px;
  color:#0588DD;
  cursor: pointer;
}

span:after {
  content: "\f054";
  font-size: 14px;
  padding-left: 14px;
  padding-right: 14px;
  color: #0588DD;
  cursor: auto;
  font-family: FontAwesome;
}

span:last-child {
  color: #4A4A4A;
  cursor: auto;
}

span:last-child:after {
  content: ''
}

@media(max-width: 980px) {
  display: none;
}
`

const TrainingThemeContent = styled.div`
padding: 0px 5%;
display: flex;
flex-direction: row;

@media(max-width: 980px) {
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  padding: 0;
}
`

const TrainingThemeLeftNav = styled.div`
display: flex;
flex-direction: column;
width: 200px;
padding-right: 5px;

@media(max-width: 980px) {
  width: 100%
  padding: 0px 5%;
  margin-top: 20px;
  align-self: flex-start;
  ${props => props.dropdownVisible ?
    'display: flex;' :
    'display: none;'
  }
}

span {
  font-family: 'Circular';
  font-weight: 300;
  font-size: 18px;
  color:#8c8c8c;
  cursor: pointer;
  margin-top: 15px;
  margin-bottom: 15px;
}

span:first-child {
  font-family: 'Circular';
  font-weight: 500;
  cursor: auto;
  text-transform: uppercase;
  color: #0588DD

  @media(max-width: 980px) {
    display: none;
  }
}
`

const TrainingThemeBody = styled.div`
background-color: #ffffff;
display: flex;
flex: 1;
margin-top: 20px;
margin-bottom: 20px;
flex-direction: column;

@media(max-width: 980px) {
  border-top: 1px solid #dddddd;
  padding: 0px 18px;
}

@media(min-width: 981px) {
  border: 1px solid #dddddd;
  padding: 70px 120px;
}
`
